/* Mobile comparison is derived from the merchant's rendered columns.
   One source of copy and claims; the original layout is the no-JS fallback. */
(function () {
  'use strict';
  // Idempotent: the section may print this script more than once (several
  // instances, editor re-renders); listeners are bound only on the first run.
  if (window.AquonNutritionCompare) return;
  function init(section) {
    if (section.dataset.ancReady) return;
    var columns = Array.from(section.querySelectorAll('.anc__col'));
    var hero = section.querySelector('.anc__col--hero');
    if (!hero || columns.length < 2) return;
    var rivals = columns.filter(function (column) { return column !== hero; });
    function text(root, selector) { var el = root.querySelector(selector); return el ? el.textContent.trim() : ''; }
    function name(column) { var logo = column.querySelector('.anc__logo'); return text(column, '.anc__name') || (logo && logo.alt) || 'AQUON'; }
    function data(column) {
      var rows = new Map();
      column.querySelectorAll('.anc__stat').forEach(function (stat, i) {
        var label = text(stat, '.anc__stat-label') || 'Detail ' + (i + 1);
        rows.set(label, text(stat, '.anc__stat-value') || '—');
      });
      return rows;
    }
    function element(tag, cls, value) { var el = document.createElement(tag); if (cls) el.className = cls; if (value != null) el.textContent = value; return el; }
    // Interface strings come from locale keys (aquon.compare.*) via data attributes
    // on [data-anc]; the English fallbacks keep older markup working unchanged.
    var ds = section.dataset;
    var t = {
      control: ds.ancLabelControl || 'Compare AQUON with',
      select: ds.ancLabelSelect || 'Choose a product to compare with AQUON',
      caption: ds.ancLabelCaption || '[hero] compared with [rival]',
      metric: ds.ancLabelMetric || 'Per serving'
    };
    var panel = element('div', 'anc-mobile');
    var control = element('label', 'anc-mobile__control', t.control);
    var select = element('select', 'anc-mobile__select');
    select.setAttribute('aria-label', t.select);
    rivals.forEach(function (rival, index) { var option = element('option', '', name(rival)); option.value = String(index); select.appendChild(option); });
    control.appendChild(select); panel.appendChild(control);
    var table = element('table', 'anc-mobile__table');
    var caption = element('caption', 'anc-mobile__caption');
    table.appendChild(caption);
    var head = element('thead'); table.appendChild(head);
    var body = element('tbody'); table.appendChild(body);
    var notes = element('div', 'anc-mobile__notes');
    panel.appendChild(table); panel.appendChild(notes);
    function identity(column, isHero) {
      var cell = element('th', isHero ? 'anc-mobile__aquon' : ''); cell.scope = 'col';
      var media = column.querySelector('.anc__media');
      if (media) { var copy = media.cloneNode(true); copy.className = 'anc-mobile__image'; copy.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); }); copy.setAttribute('aria-hidden', 'true'); cell.appendChild(copy); }
      cell.appendChild(element('span', 'anc-mobile__name', name(column)));
      cell.appendChild(element('span', 'anc-mobile__serving', text(column, '.anc__serving')));
      return cell;
    }
    function render() {
      var rival = rivals[Number(select.value)] || rivals[0];
      caption.textContent = t.caption.replace('[hero]', function () { return name(hero); }).replace('[rival]', function () { return name(rival); });
      var row = element('tr');
      var label = element('th', 'anc-mobile__metric', t.metric); label.scope = 'col';
      row.append(label, identity(hero, true), identity(rival, false)); head.replaceChildren(row);
      var a = data(hero), b = data(rival), labels = Array.from(new Set(Array.from(a.keys()).concat(Array.from(b.keys()))));
      body.replaceChildren();
      labels.forEach(function (key) {
        var tr = element('tr'), th = element('th', 'anc-mobile__metric', key.charAt(0) + key.slice(1).toLowerCase()); th.scope = 'row';
        tr.append(th, element('td', 'anc-mobile__aquon', a.get(key) || '—'), element('td', '', b.get(key) || '—')); body.appendChild(tr);
      });
      notes.replaceChildren();
      [hero, rival].forEach(function (column) { var content = [text(column,'.anc__foot-note'),text(column,'.anc__foot-flag')].filter(Boolean).join(' '); if (content) notes.appendChild(element('p', '', name(column) + ': ' + content)); });
    }
    select.addEventListener('change', render);
    render();
    section.querySelector('.anc__row').after(panel);
    section.dataset.ancReady = 'true';
    var shop = section.querySelector('[data-anc-shop]');
    if (shop) shop.addEventListener('click', function (event) {
      var target = document.querySelector('[data-apdp-atc]');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      target.focus({ preventScroll: true });
    });
  }
  function boot(scope) { scope.querySelectorAll('[data-anc]').forEach(init); }
  window.AquonNutritionCompare = { boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
